// extracted by mini-css-extract-plugin
module.exports = {"smallOverlay":"styles_smallOverlay__CkOzb"};